import { render, staticRenderFns } from "./LinkDetail.vue?vue&type=template&id=009cdf48&scoped=true"
import script from "./LinkDetail.vue?vue&type=script&lang=js"
export * from "./LinkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009cdf48",
  null
  
)

export default component.exports